IN.App.SmsverificationController = IN.App.SMSBaseController.extend({
	attempts: 1,
	tooltiptitle: "1/3 pogingen",
	tooltipmessage: "Het is mogelijk dat de SMS binnen enkele seconden binnen komt.",
	tooltiperror: "De verificatiecode is niet correct, probeer opnieuw.",
	error: false,
	smscode: null,
	smsnumber1: null,
	smsnumber2: null,
	smsnumber3: null,
	smsnumber4: null,
	smsnumber5: null,
	needs: ["application", "inputemail", "login"],

	// these properties are set from the LoginController
	sms_tracked: false,
	sms_tracking_message: "",

	sms_not_delivered: function() {
		return !this.get('sms_tracked');
	}.property('sms_tracked'),

	actions: {
		smsattempts: function(){
			var self = this;
			var appContr = this.get('controllers.application');
			var inputContr = this.get('controllers.inputemail');
			if(this.attempts < 3){
				this.set('attempts', this.attempts + 1);
				this.set('tooltiptitle', this.attempts+"/3 pogingen");
				this.set('smsnumber1', null);
				this.set('smsnumber2', null);
				this.set('smsnumber3', null);
				this.set('smsnumber4', null);
				this.set('smsnumber5', null);
				this.set('error', false);
				this.sendSMS();
			} else {
				appContr.set('sms', false);
				this.set('tooltipmessage', 'Misschien is er een probleem met je telefoonnummer, probeer een andere methode of neem contact op.')
				this.set('tooltiptitle', 'Je hebt het al 3 pogingen gedaan')
			}
		},
		sendverification: function(){

			var loginContr = this.get('controllers.login');
			var self = this;
			var data = {
				"email": loginContr.get('email'),
				"password": loginContr.get('password'),
				"auth_token": this.smscode,
				"auth_method": "sms"
			};

			$.post("/v1/auth/confirm_login", JSON.stringify(data), function(response) {

				if(response.token) {
					IN.App.TokenHelper.set(response.token);
				}

				if(response.status == 'success'){
					window.location.href = window.location.search ? '/#/' + window.location.search : '/#/';
				}
				if(response.status == 'error'){
					self.set('error', true);
				}

			}, "json");

		},
		toggletooltip: function() {

		}
	},
	smscodeObserver: function () {
	    var self = this;
	    this.set('smscode', this.smsnumber1 + this.smsnumber2 + this.smsnumber3 + this.smsnumber4 + this.smsnumber5);
  	}.observes('smsnumber1', 'smsnumber2', 'smsnumber3', 'smsnumber4', 'smsnumber5'),
	init: function () {
		this._super();
	}
});
